module.exports = __webpack_public_path__ + "static/media/parse_logo_blue.6a6dd31b.png";